import { FormModal } from '../../Form'

import { REQUEST_EDIT_USER_MODAL_FORM_BODY_PROPS } from './RequestEditUserModal.constants'
import { getRequestEditUserModalValidationSchema } from './RequestEditUserModal.utils'
import { RequestEditUserModalFields } from './RequestEditUserModalFields'

function RequestEditUserModal({
  formBodyProps = REQUEST_EDIT_USER_MODAL_FORM_BODY_PROPS,
  formFieldsProps,
  getValidationSchema = getRequestEditUserModalValidationSchema,
  id,
  initialValues,
  itemAction,
  userFieldName,
  ...restProps
}) {
  const validationSchema = getValidationSchema({
    initialValues,
    itemAction,
    userFieldName,
  })

  return (
    <FormModal
      {...restProps}
      Fields={RequestEditUserModalFields}
      formBodyProps={formBodyProps}
      formFieldsProps={{
        ...formFieldsProps,
        id,
        userFieldName,
      }}
      initialValues={initialValues}
      validationSchema={validationSchema}
    />
  )
}

export default RequestEditUserModal
